import {
  ApiBlueprint,
  createFrontendModule,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { githubActionsApiRef } from '@backstage-community/plugin-github-actions';
import { ProxiedGithubActionsClient } from './ProxiedGithubActionsClient';

// Sobrescreve a API interna do plugin github-actions (F-0029) para não
// depender de sign-in com GitHub — ver ProxiedGithubActionsClient e o
// design.md da feature (D2).
const githubActionsApiOverride = ApiBlueprint.make({
  params: define =>
    define({
      api: githubActionsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ProxiedGithubActionsClient({ discoveryApi, fetchApi }),
    }),
});

export const githubActionsAuthModule = createFrontendModule({
  pluginId: 'github-actions',
  extensions: [githubActionsApiOverride],
});
